export default "__VITE_ASSET__RSvzK5ke__"